import { render, staticRenderFns } from "./myGalleryColumns.vue?vue&type=template&id=48a4db10&scoped=true&"
import script from "./myGalleryColumns.vue?vue&type=script&lang=js&"
export * from "./myGalleryColumns.vue?vue&type=script&lang=js&"
import style0 from "./myGalleryColumns.vue?vue&type=style&index=0&id=48a4db10&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a4db10",
  null
  
)

export default component.exports